import type {ListRepresentativesSearch} from "./-types";

import {listRepresentativesQueryOptions} from "@project/application/sales/representatives";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {RepresentativesPage} from "./-page/representatives.page";
import {RepresentativesPending} from "./-page/representatives.pending";
import {listRepresentativesSearchSchema} from "./-types";

export type {ListRepresentativesSearch} from "./-types";

export const Route = createFileRoute("/_app/sales/representatives/")({
  component: RepresentativesPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(
        listRepresentativesQueryOptions(deps as ListRepresentativesSearch),
      );
    }

    void queryClient.prefetchQuery(
      listRepresentativesQueryOptions(deps as ListRepresentativesSearch),
    );

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: RepresentativesPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listRepresentativesSearchSchema.parse(search),
});
